module.exports = __webpack_public_path__ + "media/bootstrap-icons/bookmark-dash-fill-e6e204a8.svg";